import { PostDetail, PostDto, PostsDataType } from 'services/apis/cnt2/post-api';
import { P10ExhentaiContentBO, P10ExhentaiMetaBO } from 'services/gather_bo/10_exhentai';
import { P20IwaraContentBO, P20IwaraMetaBO } from 'services/gather_bo/20_iwara';
import { P30HanimeContentBO, P30HanimeMetaBO } from 'services/gather_bo/30_hanime1';
import { P40AsmroneContentBO, P40AsmroneMetaBO } from 'services/gather_bo/40_asmrone';
import { P50BilinovelContentBO, P50BilinovelMetaBO } from 'services/gather_bo/50_bilinovel';
import { P60HentaiclubContentBO, P60HentaiclubMetaBO } from 'services/gather_bo/60_hentaiclub';
import { P70SndiaryContentBO, P70SndiaryMetaBO } from 'services/gather_bo/70_sndiary';
import { P80GameContentBO, P80GameMetaBO } from 'services/gather_bo/80_game';

const P10Exhentai = 'post_10_exhentai';
const P20Iwara = 'post_20_iwara';
const P30Hanime = 'post_30_hanime';
const P40Asmrone = 'post_40_asmrone';
const P50Bilinovel = 'post_50_bilinovel';
const P60Hentaiclub = 'post_60_hentaiclub';
const P70Sndiary = 'post_70_sndiary';
const P81Acggw = 'post_81_acggw';
const P82Vikacg = 'post_82_vikacg';
const P83Acg91 = 'post_83_acg91';

export const postTypeMap = new Map([
  ['post_normal', '普通'],
  ['post_novel', '文字'],
  ['post_image', '图片'],
  ['post_video', '视频'],
  ['post_music', '音频'],
  ['post_game', '游戏'],
  ['block', '区块'],
]);

export const postSourceTypeMap = new Map([
  [P10Exhentai, '本子'],
  [P20Iwara, 'MMD'],
  [P30Hanime, '里番'],
  [P40Asmrone, '音声'],
  [P50Bilinovel, '小说'],
  [P60Hentaiclub, '套图'],
  [P70Sndiary, '合集'],
  [P81Acggw, '游戏1'],
  [P82Vikacg, '游戏2'],
  [P83Acg91, '游戏3'],
]);

export type PostDownloadTypeEnum = {
  code: String;
  name: String;
  baseUrl: String;
  notice: String;
};

// BaiduPan("BaiduPan", "百度网盘", "pan.baidu.com", "请下载到本地再解压"),
// OneDrive("OneDrive", "微软网盘", "onedrive.live.com", "请下载到本地再解压"),
// GoogleDrive("GoogleDrive", "谷歌网盘", "drive.google.com", "请下载到本地再解压"),
// MegaDrive("MegaDrive", "Mega网盘", "mega.io", "请下载到本地再解压"),
// SelfDrive("SelfDrive", "自建云存储", "drive.self.com", "请下载到本地再解压"),
export const postDownloadList: PostDownloadTypeEnum[] = [
  {
    code: 'BaiduPan',
    name: '百度网盘',
    baseUrl: 'pan.baidu.com',
    notice: '请下载到本地再解压',
  },
  {
    code: 'OneDrive',
    name: '微软网盘',
    baseUrl: 'onedrive.live.com',
    notice: '请下载到本地再解压',
  },
  {
    code: 'GoogleDrive',
    name: '谷歌网盘',
    baseUrl: 'drive.google.com',
    notice: '请下载到本地再解压',
  },
  {
    code: 'MegaDrive',
    name: 'Mega网盘',
    baseUrl: 'mega.io',
    notice: '请下载到本地再解压',
  },
  {
    code: 'SelfDrive',
    name: '自建云存储',
    baseUrl: 'self.drive',
    notice: '请下载到本地再解压',
  },
];

export const getStartTip = (postType: string, postSourceType: string): string => {
  if (postSourceType === P70Sndiary) {
    return '下载合集';
  }
  switch (postType) {
    case 'post_normal':
      return '开始下载';
    case 'post_novel':
      return '开始阅读';
    case 'post_image':
      return '开始阅读';
    case 'post_video':
      return '在线播放';
    case 'post_music':
      return '在线播放';
    case 'post_game':
      return '下载游戏';
  }
};

export type ExhentaiPostDetail = PostDetail<P10ExhentaiMetaBO, P10ExhentaiContentBO>;
export type IwaraPostDetail = PostDetail<P20IwaraMetaBO, P20IwaraContentBO>;
export type HanimePostDetail = PostDetail<P30HanimeMetaBO, P30HanimeContentBO>;
export type AsmronePostDetail = PostDetail<P40AsmroneMetaBO, P40AsmroneContentBO>;
export type BilinovelPostDetail = PostDetail<P50BilinovelMetaBO, P50BilinovelContentBO>;
export type HentaiclubPostDetail = PostDetail<P60HentaiclubMetaBO, P60HentaiclubContentBO>;
export type SndiaryPostDetail = PostDetail<P70SndiaryMetaBO, P70SndiaryContentBO>;
export type GamePostDetail = PostDetail<P80GameMetaBO, P80GameContentBO>;

export type PostDetailType =
  | ExhentaiPostDetail
  | IwaraPostDetail
  | HanimePostDetail
  | AsmronePostDetail
  | BilinovelPostDetail
  | HentaiclubPostDetail
  | SndiaryPostDetail
  | GamePostDetail;

export type PostMetaBOType =
  | P10ExhentaiMetaBO
  | P20IwaraMetaBO
  | P30HanimeMetaBO
  | P40AsmroneMetaBO
  | P50BilinovelMetaBO
  | P60HentaiclubMetaBO
  | P70SndiaryMetaBO
  | P80GameMetaBO;

export type PostConentBOType =
  | P10ExhentaiContentBO
  | P20IwaraContentBO
  | P30HanimeContentBO
  | P40AsmroneContentBO
  | P50BilinovelContentBO
  | P60HentaiclubContentBO
  | P70SndiaryContentBO
  | P80GameContentBO;

export const PostSourceType = {
  P10Exhentai,
  P20Iwara,
  P30Hanime,
  P40Asmrone,
  P50Bilinovel,
  P60Hentaiclub,
  P70Sndiary,
  P81Acggw: P81Acggw,
  P82Vikacg: P82Vikacg,
  P83Acg91: P83Acg91,
  // P91Acggw: P91Acggw,
  // P92Vikacg: P92Vikacg,
  // P93Acg91: P93Acg91,
};

export type CustomCount = {
  pageSize: number;
  column: number;
  osusumeCount: number;
  hasMenu: boolean;
};

export type DisplayModeDT = {
  pageSize: number;
  column: number;
  osusumeCount: number;
  hasMenu: boolean;
  isVertical: boolean;
};

// const imageCustomCount: CustomCount = { pageSize: 15, column: 3, osusumeCount: 9, hasMenu: true };
// const videoCustomCount: CustomCount = { pageSize: 14, column: 2, osusumeCount: 8, hasMenu: false };
// const audioCustomCount: CustomCount = { pageSize: 14, column: 2, osusumeCount: 8, hasMenu: true };
// const customCount: CustomCount = { pageSize: 14, column: 2, osusumeCount: 8, hasMenu: true };

// 接口redis缓存参数的pageSize=18
const horizontalMode: DisplayModeDT = { pageSize: 24, column: 2, osusumeCount: 6, hasMenu: true, isVertical: false };
const verticalMode: DisplayModeDT = { pageSize: 24, column: 3, osusumeCount: 6, hasMenu: true, isVertical: true };

export const getCountOnSourceType = (postSourceType: string): DisplayModeDT => {
  switch (postSourceType) {
    case P10Exhentai:
      // return imageCustomCount;
      return { ...verticalMode, hasMenu: true };
    case P20Iwara:
      // return videoCustomCount;
      return { ...horizontalMode, hasMenu: false };
    case P30Hanime:
      // return videoCustomCount;
      return { ...horizontalMode, hasMenu: false };
    case P40Asmrone:
      // return audioCustomCount;
      return { ...horizontalMode, hasMenu: true };
    case P50Bilinovel:
      // return imageCustomCount;
      return { ...verticalMode, hasMenu: true };
    case P60Hentaiclub:
      // return imageCustomCount;
      return { ...verticalMode, hasMenu: true };
    case P70Sndiary:
      // return videoCustomCount;
      return { ...horizontalMode, hasMenu: false };
    case P81Acggw:
      // case P91Acggw:
      // return videoCustomCount;
      return { ...horizontalMode, hasMenu: false };
    case P82Vikacg:
      // case P92Vikacg:
      // return videoCustomCount;
      return { ...horizontalMode, hasMenu: false };
    case P83Acg91:
      // case P93Acg91:
      // return videoCustomCount;
      return { ...horizontalMode, hasMenu: false };
  }
};
